import { CALL_API, Schemas } from '../../common/middleware/api';
import globalize from '../../common/services/globalize';
import moment from 'moment';

export const INDIVIDUAL_CONSULTATIONS_REQUEST = 'INDIVIDUAL_CONSULTATIONS_REQUEST';
export const INDIVIDUAL_CONSULTATIONS_SUCCESS = 'INDIVIDUAL_CONSULTATIONS_SUCCESS';
export const INDIVIDUAL_CONSULTATIONS_FAILURE = 'INDIVIDUAL_CONSULTATIONS_FAILURE';

export const INDIVIDUAL_CONSULTATIONS_EXPORT_REQUEST = 'INDIVIDUAL_CONSULTATIONS_EXPORT_REQUEST';
export const INDIVIDUAL_CONSULTATIONS_EXPORT_SUCCESS = 'INDIVIDUAL_CONSULTATIONS_EXPORT_SUCCESS';
export const INDIVIDUAL_CONSULTATIONS_EXPORT_FAILURE = 'INDIVIDUAL_CONSULTATIONS_EXPORT_FAILURE';

export const INDIVIDUAL_CONSULTATION_FETCH_REQUEST = 'INDIVIDUAL_CONSULTATION_GET_REQUEST';
export const INDIVIDUAL_CONSULTATION_FETCH_SUCCESS = 'INDIVIDUAL_CONSULTATION_GET_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FETCH_FAILURE = 'INDIVIDUAL_CONSULTATION_GET_FAILURE';

export const INDIVIDUAL_CONSULTATION_CREATE_REQUEST = 'INDIVIDUAL_CONSULTATION_CREATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_CREATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_CREATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_CREATE_FAILURE = 'INDIVIDUAL_CONSULTATION_CREATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_UPDATE_REQUEST = 'INDIVIDUAL_CONSULTATION_UPDATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_UPDATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_UPDATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_UPDATE_FAILURE = 'INDIVIDUAL_CONSULTATION_UPDATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_MARK_AS_PAID_REQUEST = 'INDIVIDUAL_CONSULTATION_MARK_AS_PAID_REQUEST';
export const INDIVIDUAL_CONSULTATION_MARK_AS_PAID_SUCCESS = 'INDIVIDUAL_CONSULTATION_MARK_AS_PAID_SUCCESS';
export const INDIVIDUAL_CONSULTATION_MARK_AS_PAID_FAILURE = 'INDIVIDUAL_CONSULTATION_MARK_AS_PAID_FAILURE';

export const INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_REQUEST = 'INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_REQUEST';
export const INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_SUCCESS = 'INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_SUCCESS';
export const INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_FAILURE = 'INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_FAILURE';

export const REFUND_INDIVIDUAL_CONSULTATION_REQUEST = 'REFUND_INDIVIDUAL_CONSULTATION_REQUEST';
export const REFUND_INDIVIDUAL_CONSULTATION_SUCCESS = 'REFUND_INDIVIDUAL_CONSULTATION_SUCCESS';
export const REFUND_INDIVIDUAL_CONSULTATION_FAILURE = 'REFUND_INDIVIDUAL_CONSULTATION_FAILURE';

export const INDIVIDUAL_CONSULTATION_SEND_INVOICE_REQUEST = 'INDIVIDUAL_CONSULTATION_SEND_INVOICE_REQUEST';
export const INDIVIDUAL_CONSULTATION_SEND_INVOICE_SUCCESS = 'INDIVIDUAL_CONSULTATION_SEND_INVOICE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_SEND_INVOICE_FAILURE = 'INDIVIDUAL_CONSULTATION_SEND_INVOICE_FAILURE';

export const loadIndividualConsultations = (options) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATIONS_REQUEST, INDIVIDUAL_CONSULTATIONS_SUCCESS, INDIVIDUAL_CONSULTATIONS_FAILURE],
		endpoint: 'api/individualConsultations',
		request: options,
		schema: Schemas.INDIVIDUAL_CONSULTATION_ARRAY
	},
	parentId: options.parentId
});

export const fetchIndividualConsultation = (id) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FETCH_REQUEST, INDIVIDUAL_CONSULTATION_FETCH_SUCCESS, INDIVIDUAL_CONSULTATION_FETCH_FAILURE],
		endpoint: `api/individualConsultations/${id}`,
		schema: Schemas.INDIVIDUAL_CONSULTATION
	}
});

export const updateIndividualConsultation = (id, individualConsultation) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_UPDATE_REQUEST, INDIVIDUAL_CONSULTATION_UPDATE_SUCCESS, INDIVIDUAL_CONSULTATION_UPDATE_FAILURE],
		endpoint: `api/individualConsultations/${id}`,
		method: 'PUT',
		request: individualConsultation,
		schema: Schemas.INDIVIDUAL_CONSULTATION,
		form: 'individualConsultation'
	}
});

export const markAsPaid = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_MARK_AS_PAID_REQUEST, INDIVIDUAL_CONSULTATION_MARK_AS_PAID_SUCCESS, INDIVIDUAL_CONSULTATION_MARK_AS_PAID_FAILURE],
		endpoint: `api/individualConsultations/${id}/markAsPaid`,
		method: 'PUT',
		request: options,
		schema: Schemas.INDIVIDUAL_CONSULTATION,
		form: 'markAsPaid',
		onSuccessEvent
	}
});

//export const markAsCancelled = (id) => ({
//	[CALL_API]: {
//		types: [INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_REQUEST, INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_SUCCESS, INDIVIDUAL_CONSULTATION_MARK_AS_CANCELLED_FAILURE],
//		endpoint: `api/individualConsultations/${id}/markAsCancelled`,
//		method: 'PUT',
//		schema: Schemas.INDIVIDUAL_CONSULTATION,
//	}
//});

export const refundIndividualConsultation = (id) => ({
	[CALL_API]: {
		types: [REFUND_INDIVIDUAL_CONSULTATION_REQUEST, REFUND_INDIVIDUAL_CONSULTATION_SUCCESS, REFUND_INDIVIDUAL_CONSULTATION_FAILURE],
		endpoint: `api/individualConsultations/${id}/refund`,
		method: 'PUT',
		schema: Schemas.INDIVIDUAL_CONSULTATION,
	}
});

export const exportIndividualConsultations = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [INDIVIDUAL_CONSULTATIONS_EXPORT_REQUEST, INDIVIDUAL_CONSULTATIONS_EXPORT_SUCCESS, INDIVIDUAL_CONSULTATIONS_EXPORT_FAILURE],
			endpoint: 'api/individualConsultations/export',
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			schema: Schemas.INDIVIDUAL_CONSULTATION_ARRAY,
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `IndividualConsultations-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}

export const sendInvoice = (id) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_SEND_INVOICE_REQUEST, INDIVIDUAL_CONSULTATION_SEND_INVOICE_SUCCESS, INDIVIDUAL_CONSULTATION_SEND_INVOICE_FAILURE],
		endpoint: `api/individualConsultations/${id}/sendInvoice`,
		method: 'PUT',
		schema: Schemas.INDIVIDUAL_CONSULTATION
	}
});